
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#697485","data-name":"vuesax/twotone/ticket-star"}},[_c('path',{attrs:{"d":"M5.829 2.708h8.333c1.96 0 3.053.294 3.775 1.016s1.016 1.816 1.016 3.775v5c0 1.96-.294 3.053-1.016 3.775s-1.816 1.016-3.775 1.016H5.829c-1.876 0-2.938-.265-3.665-.915s-1.074-1.691-1.118-3.443a.625.625 0 01.176-.451.625.625 0 01.445-.19A2.3 2.3 0 003.954 10a2.29 2.29 0 00-2.283-2.292.625.625 0 01-.447-.189.625.625 0 01-.178-.452c.044-1.752.379-2.782 1.119-3.444s1.788-.915 3.664-.915zm8.333 13.333c1.571 0 2.436-.194 2.891-.65s.65-1.321.65-2.891v-5c0-1.571-.194-2.436-.65-2.891s-1.319-.651-2.89-.651H5.829c-1.516 0-2.363.179-2.833.6a2.8 2.8 0 00-.672 1.961A3.546 3.546 0 015.204 10a3.554 3.554 0 01-2.881 3.478 2.805 2.805 0 00.673 1.966c.468.419 1.315.6 2.831.6z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M7.494 6.875a.625.625 0 01-.625-.625V3.333a.625.625 0 01.625-.625.625.625 0 01.625.625V6.25a.625.625 0 01-.625.625zM7.494 17.292a.625.625 0 01-.625-.625V13.75a.625.625 0 01.625-.625.625.625 0 01.625.625v2.917a.625.625 0 01-.625.625zM12.213 6.956a.96.96 0 01.868.543l.452.912 1 .145a.971.971 0 01.535 1.661l-.725.7.175 1a.969.969 0 01-1.41 1.026l-.893-.472-.9.473h-.005a.983.983 0 01-.449.11.969.969 0 01-.947-1.138l.175-1-.719-.7a.962.962 0 01-.247-.993.967.967 0 01.782-.667l1-.145.441-.9a.944.944 0 01.867-.555zm1.583 2.756l-.59-.085h-.005a.977.977 0 01-.722-.53l-.256-.525-.251.513a.945.945 0 01-.734.541l-.592.086.424.416a.979.979 0 01.277.839v.019l-.1.581.519-.274.013-.006a1.013 1.013 0 01.884 0l.013.006.519.274-.1-.581v-.019a.969.969 0 01.29-.851z","opacity":".4"}})])])
          )
        }
      }
    